module.exports = __webpack_public_path__ + "fonts/effect-fourth-wall-crawler-954b7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-fourth-wall-crawler.svg
// module id = 754
// module chunks = 0